import { render, staticRenderFns } from "./CourseReports.vue?vue&type=template&id=8780804a&scoped=true"
import script from "./CourseReports.vue?vue&type=script&lang=js"
export * from "./CourseReports.vue?vue&type=script&lang=js"
import style0 from "./CourseReports.vue?vue&type=style&index=0&id=8780804a&prod&scoped=true&lang=css"
import style1 from "./CourseReports.vue?vue&type=style&index=1&id=8780804a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8780804a",
  null
  
)

export default component.exports